<nb-card style="height: 100%;">
    <nb-card-header>
        Tasks
    </nb-card-header>

    <nb-card-body [nbSpinner]="loading">
        <div style="display: block" *ngIf="this.noTasks">
            <canvas responsive="true" maintainAspectRatio="false" baseChart [data]="doughnutChartData" [labels]="doughnutChartLabels" [chartType]="doughnutChartType"
                [colors]="chartColors" height="190" (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)"
                [options]="doughnutOptions"></canvas>
        </div>
        <div class="row" *ngIf="!this.noTasks && !this.loading">
            <div class="col-lg-12 col-12" style="text-align: center;">
                <h5 style="padding-top: 25px;">No current tasks</h5>
            </div>
        </div>
    </nb-card-body>

</nb-card>